import type { RouteRecordRaw } from 'vue-router'

/**
 * Nota: la ruta `/` ya está registrada en `router/routes.ts` (builtin) y apunta
 * a esta misma vista. Aquí solo añadimos el alias `/dashboard`.
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('./views/DashboardView.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      breadcrumb: 'Dashboard',
    },
  },
]

export default routes
